// extracted by mini-css-extract-plugin
export default {"user_badge":"userbadge_user_badge__pOgzV","user_icon":"userbadge_user_icon__6exyT"};